var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tag,{tag:"component",staticClass:"button inline-flex items-center justify-center",class:{ 'is-loading': _vm.loading },attrs:{"type":_vm.tag === 'button' && _vm.type,"to":_vm.to,"disabled":_vm.loading || _vm.disabled},on:{"click":_vm.onClick}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }